/**
 * Força o filtro "Disponibilidade > Em estoque" nas páginas de collection e search
 * quando o parâmetro filter.v.availability não está presente na URL.
 *
 * Comportamento:
 * - Entra em /collections/X → redireciona para /collections/X?filter.v.availability=1
 * - Entra em /search?q=Y    → redireciona para /search?q=Y&filter.v.availability=1
 * - Se o usuário marcar "Fora de estoque" explicitamente (=0) ou ambos, nada muda.
 * - Ignora PDPs aninhadas em /collections/X/products/Y
 * - Ignora preview do editor de tema (iframe)
 * - Suporta lojas Shopify Markets com prefixo de locale (/pt-br, /en, etc.)
 */
(function () {
  // Regra publicada para os demais módulos (ver filter-persistence.js), para que
  // ela viva num lugar só. `redirecting` avisa que este documento está prestes a
  // ser substituído e não deve ser tocado.
  window.ForcedAvailabilityFilter = {
    param: 'filter.v.availability',
    value: '1',
    redirecting: false
  };

  try {
    // 1. Skip em contexto de iframe (editor de tema, embeds)
    if (window.self !== window.top) return;

    var path = window.location.pathname;

    // 2. Detecta collection page ignorando prefixo de locale opcional
    //    e excluindo PDPs aninhadas (/collections/X/products/Y)
    var isCollection =
      /^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\//.test(path) &&
      path.indexOf('/products/') === -1;

    // 3. Detecta search page (com ou sem trailing slash, com prefixo de locale)
    var isSearch = /^(\/[a-z]{2}(-[a-z]{2})?)?\/search\/?$/.test(path);

    if (!isCollection && !isSearch) return;

    // 4. Só injeta o filtro se ele ainda não estiver presente
    var url = new URL(window.location.href);
    if (!url.searchParams.has('filter.v.availability')) {
      url.searchParams.set('filter.v.availability', '1');

      // Um redirect disparado daqui do <head> NÃO interrompe o parsing: o resto
      // do documento continua sendo montado e os scripts `defer` ainda rodam,
      // num documento que já está sendo descartado. Sinalizamos isso para que
      // eles não trabalhem à toa (nem gravem estado) — ver filter-persistence.js.
      window.ForcedAvailabilityFilter.redirecting = true;
      window.location.replace(url.toString());
      return;
    }

    // 5. A URL já está correta. Falta proteger o "Limpar tudo" (ver abaixo).
    guardClearAll();
  } catch (e) {
    // Fail silently — browser antigo, URL malformada, etc.
    // Página carrega normalmente sem o filtro forçado.
  }

  /**
   * "Limpar tudo" também precisa respeitar o estoque.
   *
   * O <facet-remove> do tema faz duas coisas ao ser clicado: navega (via AJAX)
   * para o `results_sort_url`, que carrega SÓ o `sort_by` — sem
   * `filter.v.availability` — e chama `clearCheckboxes()`, que desmarca TODOS os
   * checkboxes, inclusive o de disponibilidade. Ou seja: limpar os filtros
   * trazia os produtos esgotados de volta, e como não há recarga de página este
   * script não tinha nova chance de corrigir.
   *
   * Agimos em dois tempos:
   *   - na FASE DE CAPTURA, reescrevemos o href ANTES do handler do tema rodar
   *     (é de lá que ele extrai a query string);
   *   - num microtask, depois que o `clearCheckboxes()` já rodou, remarcamos o
   *     checkbox — senão a próxima interação serializaria o formulário sem ele.
   */
  function guardClearAll() {
    var forced = window.ForcedAvailabilityFilter;

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target || !event.target.closest) return;

        var facetRemove = event.target.closest('facet-remove');
        if (!facetRemove) return;

        var link = facetRemove.querySelector('a');
        if (!link) return;

        var linkUrl = new URL(link.href, window.location.origin);
        linkUrl.searchParams.set(forced.param, forced.value);
        link.href = linkUrl.toString();

        Promise.resolve().then(function () {
          var selector =
            'input[type="checkbox"][name="' +
            forced.param +
            '"][value="' +
            forced.value +
            '"]';

          Array.prototype.forEach.call(
            document.querySelectorAll(selector),
            function (input) {
              input.checked = true;
            }
          );
        });
      },
      true
    );
  }
})();